import angular from 'angular'

import { noargs } from './bits'
import { has, isString } from 'lodash-es'

angular
  .module('ggs.utils')
  .factory('applyAsync', applyAsyncProvider)
  .factory('ApplyAsync', ApplyAsyncProvider)

function applyAsyncProvider($parse) {
  return function applyAsync($scope, raw, ...call) {
    const parsed = isString(raw) ? $parse(raw) : raw
    const bound = has(parsed, 'oneTime')
      ? simplePartialScope(parsed, $scope, call)
      : call.length !== 0
        ? simplePartialArray(parsed, call)
        : parsed

    $scope.$applyAsync(noargs(bound))
  }
}

function ApplyAsyncProvider($parse) {
  return function ApplyAsync($scope, raw, ...init) {
    const parsed = isString(raw) ? $parse(raw) : raw
    const bound = has(parsed, 'oneTime')
      ? simplePartialScope(parsed, $scope, init)
      : init.length !== 0
        ? simplePartialArray(parsed, init)
        : parsed

    return function applyAsync(...call) {
      if (call.length === 0) {
        $scope.$applyAsync(noargs(bound))
      } else {
        $scope.$applyAsync(noargs(simplePartialArray(bound, call)))
      }
    }
  }
}

function simpleWrap(action, arg) {
  return function simpleWrap_wrapper(...call) {
    if (call.length === 0) {
      return action(arg)
    } else {
      return action.apply(null, [arg].concat(call))
    }
  }
}

function simplePartialArray(action, init) {
  return function simplePartialArray_wrapper(...call) {
    if (call.length === 0) {
      return action.apply(null, init)
    } else {
      return action.apply(null, init.concat(call))
    }
  }
}

function simplePartialScope(action, $scope, init) {
  if (init.length === 0) {
    return simpleWrap(action, $scope)
  } else {
    return simplePartialArray(action, [$scope].concat(init))
  }
}
